import React from 'react';

const HeartIcon = ({ width = '20', height = '20', color = '#778F9C', onClick }) => {
  const viewBox = `0 0 ${width} ${height}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox={viewBox}
      onClick={onClick}
    >
      <path
        fill={color}
        d="M10 20l-1.45-1.32C3.4 12.36 0 9.28 0 5.5 0 2.42 2.42 0 5.5 0 7.24 0 8.91.81 10 2.09 11.09.81 12.76 0 14.5 0 17.58 0 20 2.42 20 5.5c0 3.78-3.4 6.86-8.55 11.54L10 20z"
      ></path>
    </svg>
  );
};

export default HeartIcon;
